import AttendPayslipImport from './AttendPayslipImport';

export default AttendPayslipImport;
